module.exports = __webpack_public_path__ + "img/null.492940f3.png";